const testimonials = [
  {
    quote:
      "Guests scan the QR at the table and order themselves — our wait times dropped by half and order mistakes are gone. The kitchen display keeps every station in sync during the dinner rush.",
    name: "Gopi Sakruthi",
    role: "Owner, Eagle Food Court — Hyderabad",
    rating: 5,
  },
  {
    quote:
      "The Captain app changed how our floor runs. Staff see table status live, take orders from their phone, and it lands straight in the kitchen. Billing with GST is finally painless.",
    name: "Yerra Karthik",
    role: "Owner, Garden Kitchen — Visakhapatnam",
    rating: 5,
  },
  {
    quote:
      "We were live in under 20 minutes. Swiggy and Zomato orders now come into the same screen and reconcile automatically — no more tallying at midnight. Fair pricing and quick support.",
    name: "Priya Nair",
    role: "Owner, Spice Junction — Bengaluru",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-4">
            Testimonials
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Loved by Restaurant Owners
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Hear from the people who use EzyDinePro every day to run their
            restaurants better.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.name}
              className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-5">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-6 flex-1 italic">
                &ldquo;{testimonial.quote}&rdquo;
              </p>

              <div className="pt-5 border-t border-background-200">
                <div className="text-sm font-semibold text-foreground-950">
                  {testimonial.name}
                </div>
                <div className="text-xs text-foreground-500">{testimonial.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}